import { createAccessControl } from "better-auth/plugins/access";
import {
  adminAc,
  defaultStatements,
  userAc,
} from "better-auth/plugins/admin/access";

// Access control for Better Auth's admin plugin (#201). Shared because the
// server `admin()` plugin (worker/index.ts) and the client `adminClient()`
// (src/lib/auth-client.ts) must be configured with the same `ac`/`roles`.
// A user's role lives in `user.role` (NULL ⇒ the plugin's default "user").
// Admins assign roles from the Admin page (#206); the first admin of an
// environment is granted directly in D1.

const statement = {
  ...defaultStatements,
  // "access": the Debug screen, its /api/debug/* routes and debug-only actions
  // (e.g. recipe re-analysis). "global": Debug actions that affect more than
  // the current account — deleting global cache entries (#212).
  debug: ["access", "global"],
} as const;

export const ac = createAccessControl(statement);

// A ladder — each role is a superset of the one before it, so a user holds
// exactly one (the Admin page's picker assigns a single role).
export const roles = {
  user: ac.newRole({ ...userAc.statements }),
  // Debug tools without user management.
  debug: ac.newRole({ ...userAc.statements, debug: ["access"] }),
  admin: ac.newRole({ ...adminAc.statements, debug: ["access", "global"] }),
};

/** A set of permissions to check, e.g. `{ user: ["list"] }`. */
export type Permissions = {
  [K in keyof typeof statement]?: (typeof statement)[K][number][];
};

export const DEBUG_PERMISSION: { debug: "access"[] } = { debug: ["access"] };

/** Debug actions affecting every account (global caches, #212). */
export const DEBUG_GLOBAL_PERMISSION: { debug: "global"[] } = {
  debug: ["global"],
};

/** Access to the Admin page (user management, #206). */
export const ADMIN_PERMISSION: { user: "list"[] } = { user: ["list"] };
